// extracted by mini-css-extract-plugin
export default {"image-grid":"Image_image-grid__QQLIT","grid-image":"Image_grid-image__hJIFy","image-caption":"Image_image-caption__5vmRL"};